export const useSurveyPath = () => {
  const path = '/ui/bmi_first?f=de_de_oviva_direkt_qualification&pathway=oviva_direkt&id=4907491';

  return { path };
};
